<template>
  <div>
    <div
      class="d-flex align-items-center title-background ps-2 py-1 mouse-hover"
    >
      <div class="fw-bold px-2">
        {{ title }}
      </div>
      <RuleSelectOperator
        v-model="property.operator"
        :rule-type="propertyName"
        :operator-type="operatorType"
        @change="changeOperatorRuleType"
      />
      <div
        class="d-flex flex-row-reverse flex-grow-1 me-3"
      >
        <button
          class="focus-style fw-bold"
          type="button"
          @click="removeRuleProperty(propertyName)"
        >
          X
        </button>
      </div>
    </div>
    <MultiSelectComponent
      id="questionsSelector"
      v-model="currentArray"
      class="mb-2 my-1"
      :max-selected-options="500"
      :label="multiSelectLabel"
      :type="type"
      track-by="name"
      @input="changeSelectedValues"
    />

    <template v-if="!(['or', 'and'].includes(property.operator))">
      <div class="form-group col-sm-10">
        <label
          class="control-label"
        >{{ trans('subscription.validation_rules.filters.count') }}</label>
        <input
          v-model="property.count"
          class="form-control mb-2"
          type="number"
          min="1"
          @change="changeCountRuleType"
        >
      </div>
    </template>
  </div>
</template>

<script>
import MultiSelectComponent from '@/employees/components/FormComponents/MultiSelectComponent'
import ruleMixin from '@/employees/components/Rule/utilities/mixins/ruleMixin'
import { FILTER_OPERATOR_TYPE } from '@/constants'

export default {
  name: 'RuleMinMaxCountFilterMultiSelectCondition',
  components: { MultiSelectComponent },
  mixins: [ruleMixin],
  props: {
    parentRuleReference: {
      required: true,
      type: String,
    },
    filterRuleReference: {
      required: true,
      type: String,
    },
    property: {
      required: true,
      type: Object,
    },
    propertyName: {
      required: true,
      type: String,
    },
    title: {
      required: true,
      type: String,
    },
    multiSelectLabel: {
      required: true,
      type: String,
    },
    type: {
      required: true,
      type: String,
    },
    selectionArray: {
      required: true,
      type: Array,
    },
  },
  data () {
    return {
      currentArray: [],
      operatorType: FILTER_OPERATOR_TYPE,
    }
  },
  mounted () {
    this.currentArray = this.selectionArray
  },
  methods: {
    changeOperatorRuleType (newValue) {
      this.$root.$emit('RuleOperatorChange', [this.filterRuleReference, newValue, this.propertyName])

      if (!(['or', 'and'].includes(this.property.operator)) && this.property.count == null) {
        this.rulePropertyValueAdd(this.filterRuleReference, this.propertyName + '.count', 1)
      }
    },
    changeCountRuleType () {
      this.rulePropertyValueAdd(this.filterRuleReference, this.propertyName + '.count', Number(this.property.count))
    },
    changeSelectedValues (newValue) {
      const newValueArray = newValue.map(row => row.id)
      if (newValue.length !== this.selectionArray.length || this.arraysNotEqual(newValueArray, this.selectionArray)) {
        this.rulePropertyValueAdd(this.filterRuleReference, this.propertyName + '.in', newValueArray)
      }
    },
    arraysNotEqual (array1, array2) {
      return array1.sort().join(',') !== array2.sort().join(',')
    },
    removeRuleProperty (rulePropertyEnum) {
      this.rulePropertyValueDelete(this.filterRuleReference, rulePropertyEnum)
    },
  },
}
</script>

<style lang="scss" scoped>
.title-background {
  background-color: rgba(0, 0, 0, 0.3);
}
/deep/
.col-sm-2 {
  float: none;
}
/deep/
.col-sm-10 {
  float: none;
}
.focus-style {
  border-style: hidden;
  background: none;
  &:focus {
    border-color: #1b89ff;
    border-width: 1px;
    border-style: solid;
    box-shadow: 0 0 5px rgba(27, 137, 255, .5);
  }
}
</style>
